<div>
  <div class="header-actions">
    <h2 [innerHtml]="'popins.installation.title' | translate"></h2>
    <button class="close" (click)="close()" title="{{ 'generic.close' | translate }}">
      <span class="icon-view-close" aria-hidden="true">
        <svg>
          <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
        </svg>
      </span>
      <span>{{ 'generic.close' | translate }}</span>
    </button>
  </div>

  <div class="modal-content-body">
    <div class="installation-quote">
      <div class="row my-3 title">
        <div class="col-9">
          <h3 class="" [innerHtml]="'popins.installation.opt1_title' | translate"></h3>
        </div>
        <div class="col-3 price">
          <span>{{ beautifiedBom.totalPrice | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</span>
        </div>
      </div>

      <div class="row my-3">
        <div class="col-auto pl-5 pr-0 subtitle" [innerHtml]="'popins.installation.opt1_subtitle' | translate"></div>
        <div class="col">
          <table>
            <tr *ngFor="let productCategory of beautifiedBom.totalByCategories">
              <td><span [innerHtml]="'popins.installation.opt1_' + productCategory.key | translate"></span></td>
              <td>{{ productCategory.price | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="bg-white py-3 with-laying">
        <div class="row my-3 title">
          <div class="col-9 pr-0">
            <h3 class="" [innerHtml]="'popins.installation.opt2_title' | translate"></h3>
          </div>
          <div class="col-3 price">
            <span
              *ngIf="
                !(
                  (installationPrice === 0 && kitchenTva10 > 0) ||
                  (installationAppliancePrice === 0 && applianceTva20 > 0)
                )
              "
              >{{
                kitchenTva10 + applianceTva20 + shippingPrice + installationPrice + installationAppliancePrice
                  | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
              }}</span
            >
          </div>
        </div>

        <div class="row my-3">
          <div class="col-auto pl-5 pr-0 subtitle" [innerHtml]="'popins.installation.opt2_subtitle' | translate"></div>
          <div class="col">
            <table>
              <tr>
                <td><span [innerHtml]="'popins.installation.opt2_reduceVat' | translate"></span></td>
                <td>{{ kitchenTva10 | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
              </tr>
              <tr>
                <td><span [innerHtml]="'popins.installation.opt2_appliances' | translate"></span></td>
                <td>{{ applianceTva20 | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
              </tr>
              <tr>
                <td><span [innerHtml]="'popins.installation.opt2_installation' | translate"></span></td>
                <td class="dynamic-field">
                  <span><input type="number" min="0" [(ngModel)]="installationPrice" /> €</span>
                  <span class="formated-price">{{
                    installationPrice | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                  }}</span>
                </td>
              </tr>
              <tr>
                <td><span [innerHtml]="'popins.installation.opt2_installation_appliances' | translate"></span></td>
                <td class="dynamic-field">
                  <span><input type="number" min="0" [(ngModel)]="installationAppliancePrice" /> €</span>
                  <span class="formated-price">{{
                    installationAppliancePrice | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                  }}</span>
                </td>
              </tr>
              <tr>
                <td><span [innerHtml]="'popins.installation.opt2_shipping' | translate"></span></td>
                <td>{{ shippingPrice | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
              </tr>
            </table>
          </div>
        </div>

        <div
          class="delta"
          *ngIf="
            !((installationPrice === 0 && kitchenTva10 > 0) || (installationAppliancePrice === 0 && applianceTva20 > 0))
          "
          [innerHtml]="
            'popins.installation.opt2_delta'
              | translate
                : {
                    price:
                      kitchenTva10 +
                        applianceTva20 +
                        shippingPrice +
                        installationPrice +
                        installationAppliancePrice -
                        beautifiedBom.totalPrice | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr',
                  }
          "></div>
      </div>
    </div>

    <div class="legacy" [innerHtml]="'popins.installation.disclaimer' | translate"></div>
  </div>

  <div class="footer">
    <div class="row">
      <div class="text-left col-4">
        <ng-casto-btn
          class="light-grey"
          (click)="back()"
          [label]="'popins.installation.back' | translate"></ng-casto-btn>
      </div>
      <div class="text-right col-8">
        <ng-casto-btn class="blue" *ngIf="vendorEnvironment" (click)="order()" label="Commander"></ng-casto-btn>
        <ng-casto-btn class="blue" [loading]="printLoading" (click)="printList()" label="Imprimer"></ng-casto-btn>
      </div>
    </div>
  </div>
</div>
